import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import type { PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
  stickyBottom?: boolean;
}>;

export function InvoiceReviewActionBar({
  children,
  className,
  stickyBottom = true,
}: Props) {
  return (
    <Card
      className={cn(
        "fixed w-[50%] max-w-[800px] min-w-[500px] h-[70px] left-1/2 transform -translate-x-1/2 top-[85%] drop-shadow-lg flex items-center justify-between px-7 space-x-2",
        stickyBottom && "fixed bottom-5",
        className,
        "z-20",
      )}
    >
      {children}
    </Card>
  );
}
